import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Link' {
  interface LinkPropsColorOverrides {
    error: true;
    success: true;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsColorOverrides {
    error: true;
    success: true;
    disabled: true;
    warning: true;
  }
}

const Typography: ThemeOptions['components'] = {
  MuiLink: {
    defaultProps: {
      display: 'inline',
      underline: 'always',
    },
    styleOverrides: {
      root: {
        cursor: 'pointer',

        '&.MuiChip-root': {
          pointer: 'cursor',
        },

        '&[disabled]': {
          pointerEvents: 'none',
          color: palette.text.disabled,
        },

        '& > svg': {
          marginRight: theme.spacing(1),
          verticalAlign: 'middle',

          '& + span': {
            verticalAlign: 'middle',
          },
        },
      },
      button: {
        '&.MuiTypography-paragraph': {
          marginBottom: theme.spacing(1 / 2),
        },
        '&.MuiTypography-gutterBottom': {
          marginBottom: theme.spacing(1),
        },
      },
      underlineAlways: {
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    variants: [
      {
        props: { color: 'success' },
        style: {
          color: palette.success.main,
        },
      },
      {
        props: { color: 'error' },
        style: {
          color: palette.error.main,
        },
      },
      {
        props: { color: 'warning' },
        style: {
          color: palette.warning.main,
        },
      },
    ],
  },
  MuiTypography: {
    defaultProps: {
      display: 'block',
    },
    styleOverrides: {
      paragraph: {
        marginBottom: theme.spacing(1 / 2),
      },
      gutterBottom: {
        marginBottom: theme.spacing(1),
      },
    },
    variants: [
      {
        props: { color: 'success' },
        style: {
          color: palette.success.main,
        },
      },
      {
        props: { color: 'error' },
        style: {
          color: palette.error.main,
        },
      },
      {
        props: { color: 'disabled' },
        style: {
          color: palette.text.disabled,
        },
      },
      {
        props: { color: 'warning' },
        style: {
          color: palette.warning.main,
        },
      },
    ],
  },
};

export default Typography;
